var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BButton',{ref:"configedBtn",class:{disable: _vm.disable},attrs:{"type":"button","variant":_vm.variant,"block":_vm.block,"disabled":_vm.disable},on:{"click":_vm.clicked}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm._f("toUpperCase")(_vm.$t(_vm.label))))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }